import { defineMessages } from "react-intl";

export const messages = defineMessages({
  "strengths.header.back": {
    id: "strengths.header.back",
    defaultMessage: "Back to the dashboard",
  },
  "strengths.heading.title": {
    id: "strengths.heading.title",
    defaultMessage: "Here are my talents",
  },
  "strengths.heading.perex": {
    id: "strengths.heading.perex",
    defaultMessage:
      "Successful leaders spend most of their time developing their talents and applying them in the workplace, while simultaneously managing their weaknesses. By understanding their talents fully, they are able to focus more clearly on what they excel at.",
  },
  "strengths.first.summary": {
    id: "strengths.first.summary",
    defaultMessage: `"Did you know that you have much more potential for growth when you invest energy in developing your strengths? Many research have shown how a strengths-based approach improves your confidence, direction, and kindness toward others."`,
  },
  "strengths.first.name": {
    id: "strengths.first.name",
    defaultMessage: "Top 5 talents",
  },
  "strengths.second.summary": {
    id: "strengths.second.summary",
    defaultMessage: `"Whilst the list of your Top 5 strengths shows you the areas where you have the greatest potential to use your natural talents, here you can see the next five stenghts that you should be also aware of. They might be a big help in your professional and private life journey."`,
  },
  "strengths.second.name": {
    id: "strengths.second.name",
    defaultMessage: "Next talents",
  },
  "strengths.third.summary": {
    id: "strengths.third.summary",
    defaultMessage: `"In any role, it’s good to know your areas of lesser talent. In many cases, simply being aware of your areas of lesser talent can help you avoid major barriers. Either try to establish systems to manage them or try to partner with someone who has more talent in the areas in which you are lacking."`,
  },
  "strengths.third.name": {
    id: "strengths.third.name",
    defaultMessage: "Last talents",
  },
  "strengths.positives.title": {
    id: "strengths.positives.title",
    defaultMessage: "What's great about your talent",
  },
  "strengths.positives.title-last": {
    id: "strengths.positives.title-last",
    defaultMessage: "If these were your talents, then:",
  },
  "strengths.tips.title": {
    id: "strengths.tips.title",
    defaultMessage: "Tips for action",
  },
  "strengths.aside.title": {
    id: "strengths.aside.title",
    defaultMessage: "Find my talent assessment",
  },
  "strengths.aside.perex": {
    id: "strengths.aside.perex",
    defaultMessage: "History",
  },
  "strengths.aside.retake-button": {
    id: "strengths.aside.retake-button",
    defaultMessage: "Retake assessment",
  },
});
